import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n"; // Import the i18n configuration
import { PostHogProvider } from "posthog-js/react";
import { queryClient, trpcClient, trpcReact } from "./trpc_client";
import { QueryClientProvider } from "@tanstack/react-query";
import { debug } from "console";

// Detect and apply system theme
const applySystemTheme = () => {
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const htmlElement = document.documentElement;

  if (prefersDark) {
    htmlElement.classList.add("dark");
  } else {
    htmlElement.classList.remove("dark");
  }
};

// Apply theme on load
applySystemTheme();

// Listen for theme changes
const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
mediaQuery.addEventListener("change", applySystemTheme);

const rootElement = document.getElementById("root");

const root = ReactDOM.createRoot(rootElement!);

const hostname = window.location.hostname;
const isLocalhost =
  hostname === "localhost" || hostname === "127.0.0.1" || hostname === "[::1]";
const isDevEnv = process.env.NODE_ENV === "development";
const enablePosthog = !(isLocalhost || isDevEnv);

const posthogOptions = {
  api_host: "https://flaterooproxy.cloudflare-nq3v1.workers.dev/",
  capture_exceptions: true,
  debug: enablePosthog,
  disable_session_recording: !enablePosthog,
  disable_autocapture: !enablePosthog,
  capture_pageview: enablePosthog,
  loaded: (posthog: any) => {
    if (!enablePosthog) {
      posthog.opt_out_capturing();
    }
  },
};

root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={"phc_bExcyiWguOUataPmZFlGKjrZMdTgeGtdKwdTP8cOckJ"}
      options={posthogOptions}
    >
      <trpcReact.Provider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </trpcReact.Provider>
    </PostHogProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
